// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/illustration-template/src/index.tsx

import baseIllustration from '@bubble-ui/temp-illustration-base';
var IllustrationIncreaseOrderValuePath = 'M38.568 23.995l17.027-3.116L57.8 12l8.265 1.797L65 8.8l-29.2 3.8 2.768 11.395zm34.955-8.577L96.9 20.5 91.404 38H99.5L85.1 78.1a10.6 10.6 0 01-9.9 6.9H37.5a10.6 10.6 0 01-9.9-6.8L12.3 36.9A4.3 4.3 0 008.2 34H0v-7h8.2a11.3 11.3 0 0110.7 7.6l1.3 3.4h4.542L21.6 27.1l10.097-1.848L27.2 6.6 70.5 1l3.023 14.418zM87.9 25.7L84.043 38H65.265l-3.512-12.994L62.9 20.2l25 5.5zM31.975 38h25.996L55.3 28l-24.9 4.6 1.575 5.4zM22.8 45l11.4 30.7a3.5 3.5 0 003.3 2.3h37.7a3.5 3.5 0 003.3-2.3L89.6 45H22.8zm12.7 55a5.5 5.5 0 100-11 5.5 5.5 0 000 11zM83 94.5a5.5 5.5 0 11-11 0 5.5 5.5 0 0111 0z';
var IllustrationIncreaseOrderValue = baseIllustration('IllustrationIncreaseOrderValue', {
  getPath: () => IllustrationIncreaseOrderValuePath
}, 'ColoredIllustrationIncreaseOrderValue');

/**
 * @deprecated this component is outdated and will be removed with v6.0.0
 */
export default IllustrationIncreaseOrderValue;
//# sourceMappingURL=index.js.map